// extracted by css-extract-rspack-plugin
export default {"footerWrapper":"footer-wrapper--ZjIXtgL78eoq72Ok","totalWrap":"total-wrap--H5sCQKkGloBXIyqb"};